import { message } from 'antd';
import { useEffect } from 'react';
import { motion } from 'motion/react';
import { useParams } from 'react-router-dom';
import { LoadingSpin } from '@/components';
import { useUniversityContext, useUserContext } from '@/context';
import { UserHttp } from '@/services';
import { useTranslation } from 'react-i18next';
import { withBasePath } from '@/utils/basePath';

export function LoginCasFallback() {
  console.log('login cas fallback');

  const params = useParams();
  const [t] = useTranslation(['common']);
  const { loginCas, logout } = useUserContext();
  const { universities, setUniversity } = useUniversityContext();
  useEffect(() => {
    const access = params?.accessToken?.replace('access_token=', '');
    const refresh = params?.refreshToken?.replace('refresh_token=', '');
    const uniKey = params?.uniKey?.replace('uni_code=', '');
    if (access && refresh) {
      loginCas(access, refresh);
      const uni = universities?.find(u => u.unikey === uniKey);
      if (uni) {
        setUniversity(uni as UniversityEntity);
      }
      setTimeout(() => {
        UserHttp.getUserProfile()
          .then(() => {
            window.location.href = withBasePath('/');
          })
          .catch(() => {
            message.error({ key: 'err-auth-cas', content: t('common:errors.auth') });
            setTimeout(logout, 1200);
          });
      }, 2200);
    }
    else {
      console.log('Redirect to root');
      window.location.href = withBasePath('/');
    }
  }, [params?.accessToken, params?.refreshToken, params?.uniKey, loginCas, logout, t]);

  return (
    <div
      className="flex w-full h-full text-lg items-center justify-center text-start rtl">
      <motion.div
        initial={{ y: '10px', opacity: 0 }}
        animate={{ y: '0', opacity: 1 }}
        transition={{ duration: 0.25, delay: 0.5 }}>
        <LoadingSpin text={t('common:labels.logging-in')} />
      </motion.div>
    </div>
  );
}

export default LoginCasFallback;
